import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Gear, Trolley, ArrowRight } from "@phosphor-icons/react";

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "522282425769";


const SHOW_CATALOGUE = false;

const categories = [
    {
        id: 1,
        title: "Refacciones de Refrigeración",
        categoryName: "Refrigeración",
        description: "Compresores, gas refrigerante, motores, termostatos y ventiladores.",
        Icon: Gear,
        img: "/img/equipo1.webp",
    },
    {
        id: 2,
        title: "Equipos de Cocción",
        categoryName: "Cocción",
        description: "Venta de quemadores, válvulas de seguridad y termopares industriales.",
        Icon: Package,
        img: "/img/equipo2.webp",
    },
    {
        id: 3,
        title: "Insumos de Climatización",
        categoryName: "Climatización",
        description: "Filtros y refacciones para sistemas tipo paquete, split y mini split.",
        Icon: Trolley,
        img: "/img/equipo3.webp",
    }
];

const FeaturedProducts = () => {
    if (!SHOW_CATALOGUE) return null;

    return (
        <section id="catalogo-destacado" className="py-20 bg-white">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
                    <div className="max-w-2xl">
                        <h2 className="text-4xl font-bold text-ctex-blue mb-4">
                            Catálogo de Refacciones y Equipos
                        </h2>
                        <p className="text-gray-600 text-lg">
                            Contamos con un amplio stock de componentes originales para asegurar que sus equipos nunca se detengan.
                        </p>
                    </div>
                    <Link
                        to="/catalogo"
                        className="flex items-center gap-2 text-ctex-orange font-bold hover:gap-4 transition-all"
                    >
                        Ver catálogo completo <ArrowRight weight="bold" />
                    </Link>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {categories.map((cat) => (
                        <div
                            key={cat.id}
                            className="group bg-gray-50 rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 border border-gray-100"
                        >
                            <div className="h-48 overflow-hidden relative">
                                <img
                                    src={cat.img}
                                    alt={cat.title}
                                    loading="lazy"
                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                                />
                                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm p-2 rounded-xl text-ctex-orange shadow-sm">
                                    <cat.Icon size={24} weight="duotone" />
                                </div>
                            </div>

                            <div className="p-8">
                                <h3 className="text-xl font-bold text-gray-900 mb-3">
                                    {cat.title}
                                </h3>
                                <p className="text-gray-500 text-sm leading-relaxed mb-6">
                                    {cat.description}
                                </p>

                                <Link
                                    to="/catalogo"
                                    className="block w-full text-center py-3 border-2 border-ctex-blue text-ctex-blue font-bold rounded-xl hover:bg-ctex-blue hover:text-white transition-colors"
                                >
                                    Consultar Disponibilidad
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-16 bg-ctex-blue rounded-3xl p-8 md:p-12 text-white flex flex-col md:flex-row items-center justify-between gap-8 shadow-2xl shadow-blue-900/20">
                    <div>
                        <h4 className="text-2xl font-bold mb-2">¿Necesita una pieza específica para su equipo?</h4>
                        <p className="text-blue-100">Cuéntanos qué pieza buscas y recibe apoyo técnico especializado.</p>
                    </div>
                    <a
                        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hola, busco una refacción específica.")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-ctex-orange hover:bg-orange-600 text-white px-8 py-4 rounded-2xl font-bold transition-all transform hover:scale-105"
                    >
                        Consultar por WhatsApp
                    </a>
                </div>
            </div>
        </section>
    );
};

export default FeaturedProducts;